import { BaseService } from "./base.service";
import type { MediaDto } from "../types/media";

class MediaService extends BaseService {
  /**
   * Download multiple files as a zip archive.
   * @param keys Array of file keys to download
   * @returns Blob (zip file)
   */
  async downloadZip(memberId: string, keys: string[]): Promise<Blob> {
    // Updated endpoint: /media/{memberId}/download-zip?keys=key1,key2,key3
    const params = new URLSearchParams();
    params.append("keys", keys.join(","));
    const response = await this.get<Blob>(
      `/${memberId}/download-zip?${params.toString()}`,
      { responseType: "blob" }
    );
    return response;
  }

  constructor() {
    super("/media");
  }

  async upload(file: File, memberId: string): Promise<MediaDto> {
    const formData = new FormData();
    formData.append("file", file);
    // Use post with memberId in the path
    const response = await this.post<MediaDto>(
      `/${memberId}/upload`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response;
  }

  async download(memberId: string, key: string): Promise<Blob> {
    const response = await this.get<Blob>(`/${key}`, { responseType: "blob" });
    return response;
  }

  async deleteMedia(key: string): Promise<void> {
    await this.delete<void>(`/${key}`);
  }

  async getSignedUrl(memberId: string, fileKey: string): Promise<string> {
    const res = await this.get<{ signedUrl: string }>(
      `/${memberId}/signed-url/${encodeURIComponent(fileKey)}`
    );
    return res.signedUrl;
  }
}

export const mediaService = new MediaService();
